import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { CalendarCheck, Loader2, Trash2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Textarea } from '../../ui/textarea';
import { dateFr } from '../shared';

export const BoutonRevue = ({ onDone }) => {
  const [ouvert, setOuvert] = useState(false);
  const [commentaire, setCommentaire] = useState('');
  const [busy, setBusy] = useState(false);
  const valider = async () => {
    setBusy(true);
    try { await axios.post('/qualiopi/risques/revues', { commentaire }); toast.success('Revue annuelle enregistrée : la cartographie est figée'); setOuvert(false); setCommentaire(''); onDone(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Revue impossible'); } finally { setBusy(false); }
  };
  return (
    <>
      <Button variant="outline" onClick={() => setOuvert(true)} data-testid="risques-revue-btn"><CalendarCheck className="h-4 w-4 mr-1" /> Revue annuelle</Button>
      <Dialog open={ouvert} onOpenChange={setOuvert}>
        <DialogContent data-testid="risques-revue-dialog">
          <DialogHeader>
            <DialogTitle className="font-display text-xl">Revue annuelle des risques</DialogTitle>
            <DialogDescription>La cartographie actuelle est figée et datée : c'est la preuve de revue à présenter en audit (à faire lors de la revue de direction).</DialogDescription>
          </DialogHeader>
          <Textarea rows={3} value={commentaire} onChange={(e) => setCommentaire(e.target.value)} placeholder="Participants, décisions, risques ajoutés ou retirés…" data-testid="risques-revue-commentaire" />
          <Button onClick={valider} disabled={busy} className="bg-[#0F172A] text-white hover:bg-[#1e293b]" data-testid="risques-revue-valider">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Figer la cartographie'}</Button>
        </DialogContent>
      </Dialog>
    </>
  );
};

export const ListeRevues = ({ revues, onChanged }) => {
  const supprimer = async (id) => {
    try { await axios.delete(`/qualiopi/risques/revues/${id}`); toast.success('Revue supprimée'); onChanged(); } catch { toast.error('Suppression impossible'); }
  };
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4" data-testid="risques-revues">
      <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-slate-500">Revues annuelles</p>
      {revues.length === 0
        ? <p className="text-sm text-amber-700" data-testid="risques-revues-vide">Aucune revue enregistrée : faites-en une au moins une fois par an.</p>
        : <ul className="space-y-2">{revues.map((r) => (
          <li key={r.revue_id} className="flex items-start gap-2 text-sm" data-testid={`revue-${r.revue_id}`}>
            <CalendarCheck className="mt-0.5 h-4 w-4 shrink-0 text-[#8DC63F]" />
            <span className="min-w-0 flex-1"><b>{dateFr(r.date)}</b> · {r.par} · {r.nb} risques dont {r.eleves} élevé(s){r.commentaire && <span className="block text-xs text-slate-500">{r.commentaire}</span>}</span>
            <button type="button" onClick={() => supprimer(r.revue_id)} className="p-1 text-slate-400 hover:text-red-600" title="Supprimer" data-testid={`revue-supprimer-${r.revue_id}`}><Trash2 className="h-3.5 w-3.5" /></button>
          </li>
        ))}</ul>}
    </div>
  );
};
